import moment from 'moment'
import { i18n } from '@/plugins/vueI18n.js'

export function convertToISO (dateString, fromFormat) {
  return moment(dateString, fromFormat).format('YYYY-MM-DD')
}

export function getToday (format) {
  return moment().format(format)
}

export function createNestedObject (inputString, value) {
  const segments = inputString.substr(2).split('.')
  const obj = {}

  // Traverse through the segments
  let currentObj = obj
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i]
    const isArray = /\[\]$/.test(segment) // Check if it's an array

    if (isArray) {
      const key = segment.replace(/\[\]$/, '') // Remove array index

      // Create an array if it doesn't exist
      currentObj[key] = currentObj[key] || []

      // If it's the last segment, push the value into the array
      if (i === segments.length - 1) {
        currentObj[key].push(value)
      } else {
        // Otherwise, create an object
        currentObj[key].push({})
        currentObj = currentObj[key][currentObj[key].length - 1]
      }
    } else {
      // Create an object for non-array segments
      currentObj[segment] = i === segments.length - 1 ? value : {}
      currentObj = currentObj[segment]
    }
  }

  return obj
}

export function merge (obj1, obj2) {
  const output = {
    ...obj2
  } // Start with a copy of obj2

  for (const key in obj1) {
    if (obj1.hasOwnProperty(key)) {
      if (obj2.hasOwnProperty(key)) {
        // If both objects have the same property, merge the values
        if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
          // Recursively merge nested objects
          output[key] = merge(obj1[key], obj2[key])
        } else {
          // Otherwise, overwrite obj2's value with obj1's value
          output[key] = obj1[key]
        }
      } else {
        // If obj2 doesn't have the property, add it from obj1
        output[key] = obj1[key]
      }
    }
  }
  return output
}

export function getAccountLabel (accountType) {
  const map = {
    SVGS: i18n.t('termDepositActions.listAC.savingsLabel'),
    TXSV: i18n.t('termDepositActions.listAC.cashIsaLabel'),
    CACC: i18n.t('termDepositActions.listAC.currentLabel'),
    TXEA: i18n.t('termDepositActions.listAC.txeaCashIsaLabel'),
    NACC: i18n.t('termDepositActions.listAC.noticeLabel'),
    TXFR: i18n.t('termDepositActions.listAC.txfrCashIsaLabel'),
    TXNA: i18n.t('termDepositActions.listAC.taxNoticeLabel')
  }
  return map[accountType] ?? ''
}
